import { DEFAULT_PAGINATION_PAGE } from '~/common/constants/common.constant';

export const DEFAULT_FAILED_VEHICLES_PAGINATION_MAX_ROWS_PER_PAGE = 5;
export const DEFAULT_FAILED_VEHICLES_PAGINATION_OPTIONS = {
  pageIndex: DEFAULT_PAGINATION_PAGE,
  pageSize: DEFAULT_FAILED_VEHICLES_PAGINATION_MAX_ROWS_PER_PAGE,
};
